export default [
  {
    content: "작업계획서를 작성하고 계획에 따라 작업하는가?",
    isChecked: "",
  },
  {
    content: "작업지휘자를 지정하여 작업계획서에 따라 작업을 지휘하는가?",
    isChecked: "",
  },
  {
    content: "청소차 적재함 등 승차석이 아닌 위치에 근로자가 탑승하지는 않는가?",
    isChecked: "",
  },
  {
    content: "운전자는 제한속도를 준수하는가?",
    isChecked: "",
  },
  {
    content: "운전자가 운전위치 이탈 시 시동키 분리 등 안전사항을 지키는가?",
    isChecked: "",
  },
  {
    content: "하역·운반 중인 화물이나 차량계 하역운반기계에 접촉될 우려가 있는 곳에는 근로자의 출입을 금지하는가?",
    isChecked: "",
  },
  {
    content: "차량계 하역운반기계에 화물 적재 시 운전자의 시야 확보 등 안전사항을 지키는가?",
    isChecked: "",
  },
  {
    content: "차량계 하역운반기계를 화물자동차에 싣거나 내리는 작업을 할 때 전도·전락 위험을방지하고있는가?",
    isChecked: "",
  },
  {
    content: "차량계 하역운반기계는 화물의 적재·하역 등 주된 용도에만 사용하는가?",
    isChecked: "",
  },
  {
    content: "차량계 하역운반기계의 수리 또는 부속장치의 장착 및 해체작업 시 작업 지휘자를 지정하여 작업을 지휘하는가?",
    isChecked: "",
  },
  {
    content: "차량에는 백밀러. 룸밀러 및 CCTV 등이 설치되었는가?",
    isChecked: "",
  },
  {
    content: "운전자는 운전 시 안전벨트를 항상 착용하는가?",
    isChecked: "",
  },
  {
    content: "차량은 정기적으로 검사를 받고 있는가?",
    isChecked: "",
  },
  {
    content: "폐기물을 하역하는 동안 차량들은 차량 하나의 넓이만큼 서로 떨어져 있는가?",
    isChecked: "",
  },
  {
    content: "모든 근로자들은 작업장 내에서 쉽게 눈에 띄는 작업복을 착용하는가?",
    isChecked: "",
  },
];
